module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/1cc897cea9a7dcc3063ec9944bee291c.svg";